import * as React from 'react';

import * as styles from './index.css';

export class BtiContainer extends React.Component<{}, {}> {
  public render() {
    return <div className={styles['container']}>{this.props.children}</div>;
  }
}
